const root = '/';

const URL = {
    HOME: root,
    CONSUMER_LOAN_SUMULATOR: 'urls.consumer-loan-simulator',
    CONSUMER_LOAN_SUCCESS: 'urls.consumer-loan-success'
};

export default URL;
